// @flow
import React, { Component } from 'react'
import { HeaderCell, HeaderRow, Link } from '../MainTable'
import styled, { type StyledComponent } from 'styled-components'
import type { GroupedHeaders } from '../controls/groupHeaders'
import { fixedCellCommonStyle } from './Table'
import _ from 'lodash'
import classNames from 'classnames'

const Delimiter: StyledComponent<Object, any, any> = styled.div`
  width: 15px;
`
const StyledHeaderCell: StyledComponent<Object, any, any> = styled(HeaderCell)`
  font-weight: bold;
  font-size: 10px;
  padding: 9px 5px;
  text-align: center;
  border-bottom: 1px solid #d1d1d1;
  border-right: 1px solid #d1d1d1;
`
const FixedHeaderCell: StyledComponent<Object, any, any> = styled(StyledHeaderCell)`
  ${fixedCellCommonStyle}
`

type Props = {|
  data: Object,
  groupedHeaders: GroupedHeaders,
  t: Function,
  headerColSpan: number,
  sortDirection: 'asc' | 'desc' | 'none',
  sortIndex: number,
  onColumnClick: Function
|}

export default class Thead extends Component<Props> {
  render() {
    const { data, groupedHeaders, t, headerColSpan } = this.props
    return (
      <thead>
        <HeaderRow>
          <FixedHeaderCell minimal />
          {_.map(groupedHeaders, (headers, type: string) => {
            return (
              !_.isEmpty(headers) && (
                <StyledHeaderCell key={type} colSpan={headerColSpan * headers.length}>
                  {t(type)}
                </StyledHeaderCell>
              )
            )
          })}
        </HeaderRow>
        <HeaderRow>
          <FixedHeaderCell minimal>{data.label_header}</FixedHeaderCell>
          {_.map(_.flatten(_.values(groupedHeaders)), (header, index: number) =>
            this.renderSortableHeader(header, index)
          )}
        </HeaderRow>
        {!_.isEmpty(data.sub_headers) && (
          <HeaderRow>
            <FixedHeaderCell />
            {_.map(_.flatten(_.values(groupedHeaders)), (header, headerIndex: number) => [
              <StyledHeaderCell key={headerIndex}>
                <Delimiter />
              </StyledHeaderCell>,
              _.map(data.sub_headers, (subHeader, subHeaderIndex: number) => (
                <StyledHeaderCell key={`${headerIndex}_${subHeaderIndex}`}>
                  {subHeader}
                </StyledHeaderCell>
              ))
            ])}
          </HeaderRow>
        )}
      </thead>
    )
  }

  renderSortableHeader(headerText: string, index: number) {
    const { sortDirection, sortIndex, headerColSpan, onColumnClick } = this.props

    const direction = sortIndex === index ? sortDirection : 'none'

    return (
      <StyledHeaderCell key={index} colSpan={headerColSpan}>
        <span onClick={() => onColumnClick(index)}>
          <Link className="t-SortLink">{headerText}</Link>
          <i
            className={classNames('sort-order-arrow', {
              'sort-order-arrow_desc': direction === 'desc',
              'sort-order-arrow_asc': direction === 'asc'
            })}
          />
        </span>
      </StyledHeaderCell>
    )
  }
}
